/**
 * SectionContent — constrains content to max-w-7xl, centered, with consistent horizontal padding.
 * Use inside any full-width section so the background spans the viewport but content stays centered.
 *
 * @example
 * <section className="py-12 bg-surface">
 *   <SectionContent>
 *     <h2>Heading</h2>
 *   </SectionContent>
 * </section>
 */
export default function SectionContent({ children, className = "" }) {
  return (
    <div className={`w-full max-w-7xl mx-auto px-4 sm:px-8 ${className}`.trim()}>{children}</div>
  );
}
